import { Trans } from 'react-i18next';
import { ReactNode } from 'react';

import {
   AlertCircleIcon,
   appendTestableElementAttributes,
   IconFillColor,
   IconSize,
   StyledFlex,
   Text,
} from '@dreryk/react-components';
import { hourMinuteFormatter, Translate } from '@dreryk/react-common';

import { compact } from '~libs.typescript';

import { translationKeys } from '../translations';

import {
   StyledEmergencyNotificationAlertItem,
   StyledEmergencyNotificationAlertItemDismissedLabel,
   StyledEmergencyNotificationAlertItemIcon,
} from './EmergencyNotificationAlertItem.styled';
import { EmergencyNotificationAlert } from './types';

type EmergencyNotificationAlertItemProps = Readonly<{
   emergencyNotification: EmergencyNotificationAlert;
   button?: ReactNode;
}>;

export const EmergencyNotificationAlertItem = (props: EmergencyNotificationAlertItemProps): JSX.Element => {
   return (
      <StyledEmergencyNotificationAlertItem
         {...appendTestableElementAttributes('emergencyNotificationAlertItem')}
         $dismissed={props.emergencyNotification.dismissed}
      >
         <StyledFlex alignItems={'center'} gap={'8px'}>
            <StyledEmergencyNotificationAlertItemIcon
               testId={'alert'}
               size={IconSize.NORMAL}
               fillColor={props.emergencyNotification.dismissed ? IconFillColor.INHERIT : IconFillColor.ERROR}
            >
               <AlertCircleIcon />
            </StyledEmergencyNotificationAlertItemIcon>
            <StyledFlex direction={'column'} gap={'8px'}>
               <Text testId={'reporterName'}>
                  <Trans
                     i18nKey={translationKeys.reporterWithName}
                     values={{
                        name: compact([
                           props.emergencyNotification.reporterTitle,
                           props.emergencyNotification.reporterFirstName.asString(),
                           props.emergencyNotification.reporterLastName.asString(),
                        ]).join(' '),
                     }}
                     components={{ bold: <strong /> }}
                  />
               </Text>
               <Text testId={'time'}>
                  <Trans
                     i18nKey={translationKeys.time}
                     values={{ time: hourMinuteFormatter(props.emergencyNotification.notificationTime) }}
                  />
               </Text>
            </StyledFlex>
         </StyledFlex>

         {props.emergencyNotification.dismissed ? (
            <StyledEmergencyNotificationAlertItemDismissedLabel testId={'dismissed'}>
               <Translate>{translationKeys.sosAlarmDismissed}</Translate>
            </StyledEmergencyNotificationAlertItemDismissedLabel>
         ) : (
            props.button
         )}
      </StyledEmergencyNotificationAlertItem>
   );
};
